import api from "../config/Api";
import { config } from "../config/host";

/*
|--------------------------------------------------------------------------
| Encode / Decode Base64 Safe
|--------------------------------------------------------------------------
*/

const encode = (val) => {
  try {
    return btoa(unescape(encodeURIComponent(val)));
  } catch {
    return null;
  }
};

const decode = (val) => {
  try {
    return decodeURIComponent(escape(atob(val)));
  } catch {
    return null;
  }
};

/*
|--------------------------------------------------------------------------
| Cookie Helpers
|--------------------------------------------------------------------------
*/

const setCookie = (name, value, days = 7) => {
  const encoded = encode(value);
  if (!encoded) return;

  const date = new Date();
  date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);

  document.cookie = `${name}=${encoded};expires=${date.toUTCString()};path=/;Secure;SameSite=Strict`;
};

const deleteCookie = (name) => {
  document.cookie = `${name}=; Max-Age=0; path=/`;
};

const clearAuth = () => {
  deleteCookie("token");
  deleteCookie("user");
};

const getCookie = (name) => {
  const match = document.cookie.match(new RegExp("(^| )" + name + "=([^;]+)"));

  if (!match) return null;

  const decoded = decode(match[2]);

  if (!decoded) {
    deleteCookie(name);
    return null;
  }

  return decoded;
};

/*
|--------------------------------------------------------------------------
| Auth Service
|--------------------------------------------------------------------------
*/

export const Auth = {
  async isAuthenticated() {
    const token = getCookie("token");
    const user = getCookie("user");

    if (!token || !user) {
      clearAuth();
      return false;
    }

    try {
      const response = await api.post(
        "/api/validate-token",
        {},
        { headers: { Authorization: `Bearer ${token}` } },
      );

      if (response.data.valid !== true) {
        clearAuth();
        return false;
      }

      return true;
    } catch (error) {
      console.error("Token validation failed:", error);
      clearAuth();
      return false;
    }
  },

  async login(email, password, cb) {
    try {
      const response = await api.post("/api/login", { email, password });
      const { token, user } = response.data.data;

      setCookie("token", token);
      setCookie("user", JSON.stringify(user));

      if (cb) cb();
    } catch (err) {
      console.error("Login error:", err);
      clearAuth();
      if (cb) cb(err);
    }
  },

  async loginWithGoogle(idToken, cb) {
    try {
      const response = await api.post("/api/auth/google-login", {
        id_token: idToken,
      });

      const { token, user } = response.data.data;

      setCookie("token", token);
      setCookie("user", JSON.stringify(user));

      if (cb) cb();
    } catch (err) {
      console.error("Login with Google failed:", err);
      clearAuth();
      if (cb) cb(err);
    }
  },

  async RegisterWithGoogle(idToken, cb) {
    try {
      const response = await api.post("/api/auth/google-register", {
        id_token: idToken,
      });

      const { token, user } = response.data.data;

      setCookie("token", token);
      setCookie("user", JSON.stringify(user));

      if (cb) cb();
    } catch (err) {
      clearAuth();
      if (cb) cb(err);
    }
  },

  async logout(cb) {
    try {
      const token = getCookie("token");

      if (token) {
        await api.post(
          "/api/logout",
          {},
          { headers: { Authorization: `Bearer ${token}` } },
        );
      }

      clearAuth();
      window.location.href = `${config.subPath}login`;

      if (cb) cb();
    } catch (err) {
      console.error("Logout error:", err);
      clearAuth();
      if (cb) cb(err);
    }
  },

  /**
   * Kirim link reset password ke email.
   * Backend selalu return sukses meski email tidak terdaftar (anti enumeration).
   */
  async forgotPassword(email, cb) {
    try {
      await api.post("/api/forgot-password", { email });
      if (cb) cb();
    } catch (err) {
      console.error("Forgot password error:", err);
      if (cb) cb(err);
    }
  },

  /**
   * Reset password menggunakan token dari link email.
   * @param {string} token  - Token dari query param URL
   * @param {string} email  - Email dari query param URL
   * @param {string} password          - Password baru
   * @param {string} password_confirmation - Konfirmasi password baru
   */
  async resetPassword(token, email, password, password_confirmation, cb) {
    try {
      await api.post("/api/reset-password", {
        token,
        email,
        password,
        password_confirmation,
      });
      if (cb) cb();
    } catch (err) {
      console.error("Reset password error:", err);
      if (cb) cb(err);
    }
  },

  getUser() {
    const user = getCookie("user");

    if (!user) return null;

    try {
      return JSON.parse(user);
    } catch {
      deleteCookie("user");
      return null;
    }
  },

  getToken() {
    const token = getCookie("token");

    if (!token) {
      clearAuth();
      return null;
    }

    return token;
  },
};
